/* eslint-disable no-restricted-imports */
/* eslint-disable functional/no-loop-statement */
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC, useEffect, useRef, useState } from 'react';
import { CenterContainer } from '@/components/blocks/CenterContainer';
import { ScrollContainer } from '@/components/blocks/ScrollContainer';
import { Grid, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { formattedCatalogEntryCarouselId } from 'integration/utils/formattedCatalogEntryCarouselId';
import { useCarouselScrollState } from '@/utils/useCarouselScrollState';

export const CatalogEntryCarouselSearch: FC<{
	id: string;
	slides: JSX.Element[];
	initialHidden?: boolean;
}> = ({ id, slides, initialHidden }) => {
	const scrollContainerRef = useRef<HTMLDivElement>(null);
	const [positions, setPositions] = useState<number[]>([]);
	const [positionActive, setPositionActive] = useState<number>(200);

	const { hasOverflow, isEndReached } = useCarouselScrollState(scrollContainerRef, slides.length);

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	useEffect(() => {
		if (positions.length === 0) {
			const positionsTemp = [];
			for (let i = 0; i < slides.length; i++) {
				positionsTemp.push(i * 200);
			}
			setPositions(positionsTemp);
		}
		const handleScroll = () => {
			if (scrollContainerRef.current) {
				const { scrollLeft } = scrollContainerRef.current;
				const responses = positions.filter((e) => e > scrollLeft);
				setPositionActive(responses[0]);
			}
		};

		const node = scrollContainerRef.current;
		node?.addEventListener('scroll', handleScroll);
		return () => node?.removeEventListener('scroll', handleScroll);
	}, [positions, slides.length]);

	const handleScrollRight = () => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollTo({
				left: positionActive,
				behavior: 'smooth',
			});
		}
	};

	const handleScrollLeft = () => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollTo({
				left: positionActive - (isEndReached ? 200 : 400),
				behavior: 'smooth',
			});
		}
	};

	return (
		<CenterContainer
			sx={{
				position: 'relative',
				maxWidth: '860px',
				display: initialHidden ? 'none' : 'grid',
			}}
			id={formattedCatalogEntryCarouselId(id)}
		>
			<ScrollContainer
				sx={{
					pb: {
						xs: '0px',
						sm: '0px',
					},
				}}
				ref={scrollContainerRef}
			>
				<Grid container wrap="nowrap" alignItems={'center'}>
					{slides.map((value, index) => (
						<Grid item key={`id_see_you_recent_${index}`} sx={{ mr: { xs: '8px', sm: '20px' } }}>
							{value}
						</Grid>
					))}
					{!isMobile && hasOverflow && positionActive - (isEndReached ? 0 : 200) > 0 ? (
						<IconButton
							onClick={handleScrollLeft}
							sx={{
								height: '38px',
								width: '38px',
								position: 'absolute',
								left: '-80px',
								backgroundColor: '#F1F1F1',
								':hover': { backgroundColor: '#F1F1F1' },
							}}
						>
							<ChevronLeft sx={{ color: 'text.primary' }} />
						</IconButton>
					) : null}
					{!isMobile && hasOverflow && !isEndReached ? (
						<IconButton
							onClick={handleScrollRight}
							sx={{
								height: '38px',
								width: '38px',
								position: 'absolute',
								right: '-80px',
								backgroundColor: '#F1F1F1',
								':hover': { backgroundColor: '#F1F1F1' },
							}}
						>
							<ChevronRight sx={{ color: 'text.primary' }} />
						</IconButton>
					) : null}
				</Grid>
			</ScrollContainer>
		</CenterContainer>
	);
};
